import React, { Fragment } from "react";
import { Input, Form, Select, Table, Popconfirm, Tooltip, Tag, Button } from "antd";

import styles from "../management.module.scss";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { CharacterVerify } from "../../../Utility/RegExp";

const { Option } = Select;

interface editUserProps {
  deviceGroupsFetching: boolean;
  EditUserform: any;
  users: any;
  deviceGroups: any;
  editingKey: any;
  setEditingKey: any;
  deleteUser: (arg: any) => void;
  EditUseronFinish: (arg: any) => void;
}

const EditUserModal = React.memo(
  ({
    EditUserform,
    deviceGroupsFetching,
    users,
    deviceGroups,
    editingKey,
    setEditingKey,
    deleteUser,
    EditUseronFinish,
  }: editUserProps) => {
    const { t } = useTranslation();
    const { level, user } = useAppSelector((state) => state.global);

    const edit = (index: any) => {
      setEditingKey(index);
    };

    const cancel = () => {
      setEditingKey("");
    };

    const columns = [
      {
        title: t("ISMS.name"),
        dataIndex: ["name"],
        render: (_: string, record: any, index: number) => {
          return (
            <Fragment>
              {record.name}
              <Form.Item
                style={{ display: "none", marginBottom: 0 }}
                name={["EditUser", index, "name"]}
                rules={[{ required: true, message: "Group is required!" }, CharacterVerify]}
                initialValue={record.name}
              >
                <Input disabled={true} />
              </Form.Item>
            </Fragment>
          );
        },
      },
      {
        title: t("ISMS.password"),
        editable: true,
        dataIndex: ["password"],
        render: (_: string, __: any, index: any) => {
          return index === editingKey ? (
            <Form.Item
              style={{ marginBottom: 0 }}
              name={["EditUser", index, "password"]}
              rules={[
                {
                  whitespace: true,
                  message: "spaces are not allow!",
                },
                CharacterVerify,
              ]}
            >
              <Input.Password
                placeholder={t("ISMS.Newpassword(optional)")}
                style={{ width: "200px" }}
                autoComplete="new-password"
              />
            </Form.Item>
          ) : (
            "******"
          );
        },
      },
      {
        title: t("ISMS.level"),
        editable: true,
        dataIndex: ["level"],
        render: (text: string, record: any, index: any) => {
          return (
            <Fragment>
              {index !== editingKey && text}
              <Form.Item
                style={index !== editingKey ? { display: "none" } : { marginBottom: 0 }}
                name={["EditUser", index, "level"]}
                rules={[{ required: true, message: "level is required!" }]}
                initialValue={record.level}
              >
                <Select
                  placeholder={t("ISMS.Selectlevel")}
                  style={{ width: "100px" }}
                  disabled={
                    (record.level === "super" && level !== "super_super") ||
                    (record.level === "admin" && level === "admin")
                  }
                >
                  {level === "super_super" && (
                    <Option key={1} value={"super"}>
                      super
                    </Option>
                  )}
                  {level !== "admin" && (
                    <Option key={2} value={"admin"}>
                      admin
                    </Option>
                  )}
                  <Option key={3} value={"get"}>
                    get
                  </Option>
                  <Option key={4} value={"set"}>
                    set
                  </Option>
                </Select>
              </Form.Item>
            </Fragment>
          );
        },
      },
      {
        title: t("ISMS.Group"),
        editable: true,
        dataIndex: ["gid"],
        render: (_: string, record: any, index: any) => {
          return (
            <Fragment>
              {index !== editingKey && record?.gid?.map((item: any, index: number) => <Tag key={index}>{item}</Tag>)}
              <Form.Item
                style={index !== editingKey ? { display: "none" } : { marginBottom: 0 }}
                name={["EditUser", index, "gid"]}
                initialValue={record.gid}
              >
                <Select
                  mode="multiple"
                  placeholder={t("ISMS.SelectGroup")}
                  showArrow
                  style={{ width: "300px" }}
                  disabled={record.level === "super" || level === "admin"}
                  loading={deviceGroupsFetching}
                >
                  {deviceGroups?.group_list?.map((item: any) => {
                    return (
                      <Option key={index} value={item.gid}>
                        {item.gid}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Fragment>
          );
        },
      },
      {
        title: t("ISMS.Operation"),
        dataIndex: "Operation",
        render: (_: string, record: any, index: any) => {
          return index === editingKey ? (
            <Button
              onClick={() => {
                cancel();
                EditUserform.setFieldsValue({
                  EditUser: users || [],
                });
              }}
            >
              {t("ISMS.Cancel")}
            </Button>
          ) : (
            <div className="flex justify-center">
              {(record.level === "admin" && level === "admin" && record.name !== user) ||
              (record.level === "super" && level === "super" && record.name !== user) ? null : (
                <Tooltip title={t("ISMS.Edit")}>
                  <Button onClick={() => edit(index)} type="text" icon={<EditOutlined />}></Button>
                </Tooltip>
              )}
              {level === "super_super" || record.level !== "super" ? (
                record.level === "admin" && level === "admin" ? null : (
                  <Tooltip title={t("ISMS.Delete")}>
                    <Popconfirm
                      title={t("ISMS.Sure to delete?")}
                      onConfirm={() => {
                        deleteUser(record);
                      }}
                    >
                      <Button type="text" icon={<DeleteOutlined />}></Button>
                    </Popconfirm>
                  </Tooltip>
                )
              ) : null}
            </div>
          );
        },
      },
    ];

    return (
      <Form form={EditUserform} onFinish={EditUseronFinish} style={{ overflowX: "auto" }} layout="vertical">
        <Table
          columns={columns}
          loading={deviceGroupsFetching}
          dataSource={users || []}
          pagination={false}
          className={styles.table}
          rowClassName="editable-row"
        />
      </Form>
    );
  }
);

export default EditUserModal;
